// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';

import { Label, Input } from '../atoms';
import { theme } from '../theme';

export type FieldProps = {
  label?: Node,
  children?: Node,
  hint?: Node,
  hasError?: boolean | null | typeof undefined,
  error?: Node,
};

export function Field({ label, children, error, ...rest }: FieldProps): Node {
  const wrapperProps: any = { ...rest };

  if (wrapperProps.hasError) {
    wrapperProps['data-error'] = true;
  }

  return (
    <Wrapper {...wrapperProps}>
      {label}
      {children}
      <SubContentWrapper>
        <p><strong>{rest.hasError && error}</strong></p>
        <p><i>{rest.hint}</i></p>
      </SubContentWrapper>
    </Wrapper>
  );
}

const SubContentWrapper = styled.div`
  font-size: 0.8em;
`;

const Wrapper = styled.div`
  &:nth-last-child(n+2) {
    margin-bottom: 1em;
  }

  ${({ hasError }) => hasError && css`
    color: ${theme.colors.danger(42)};

    ${Input} {
      color: ${theme.colors.danger(50)};
      border-color: ${theme.colors.danger(79)};
      background-color: ${theme.colors.danger(98, 0.75)};

      :focus {
        color: ${theme.colors.gray(0, 0.8)};
        border-color: ${theme.colors.danger(48)};
      }
    }
  `}

  ${Label} {
    padding-top: 0.2em;
  }

  ${Label}, ${Input} {
    width: 100%;
    display: block;
    line-height: 1.5;
  }
`;
